import React from 'react';
import { Link } from 'react-router-dom';

const ProduccionIndex = () => (
  <div className="p-8 max-w-4xl">
    <h1 className="text-2xl font-semibold text-gray-900 mb-2">Producción</h1>
    <p className="text-gray-600 mb-8">
      Catálogo general de recetas y su clasificación. Los flujos de planta concesionaria (cíclicos, despacho, etc.)
      siguen en <strong>Producción concesionaria</strong>.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <Link
        to="/produccion/reportes/dashboard"
        className="block p-5 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50/40 transition-colors"
      >
        <span className="text-2xl" aria-hidden>
          📈
        </span>
        <h2 className="mt-2 font-medium text-gray-900">Dashboard</h2>
        <p className="text-sm text-gray-500 mt-1">KPIs, tendencia y top recetas de las guías de producción.</p>
      </Link>
      <Link
        to="/produccion/clasificacion-recetas/categorias"
        className="block p-5 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50/40 transition-colors"
      >
        <span className="text-2xl" aria-hidden>
          📜
        </span>
        <h2 className="mt-2 font-medium text-gray-900">Recetas</h2>
        <p className="text-sm text-gray-500 mt-1">Clasificación de recetas y fichas técnicas de elaboración.</p>
      </Link>
      <Link
        to="/produccion/guias"
        className="block p-5 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50/40 transition-colors"
      >
        <span className="text-2xl" aria-hidden>
          📋
        </span>
        <h2 className="mt-2 font-medium text-gray-900">Guías de producción</h2>
        <p className="text-sm text-gray-500 mt-1">Registro de elaboración por producto terminado o en proceso.</p>
      </Link>
      <Link
        to="/produccion/reportes/uso-insumo"
        className="block p-5 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50/40 transition-colors"
      >
        <span className="text-2xl" aria-hidden>
          📊
        </span>
        <h2 className="mt-2 font-medium text-gray-900">Reportes</h2>
        <p className="text-sm text-gray-500 mt-1">Consultas sobre recetas e insumos utilizados.</p>
      </Link>
    </div>
  </div>
);

export default ProduccionIndex;
